// ModalHint.jsx

import React from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './ModalHint.css';

/**
 * ModalHint
 * 
 * A simple hint component for modals.
 *  
 * @param {string} hint - The text to display inside the hint.
 * 
 * @returns {ReactNode} - ModalHint.
 */
const ModalHint = React.memo(({ hint }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- RENDER ----- //

    if (!hint || hint.trim() === '') return null;

    return (

        <div
            className="modal-hint-container"
            style={{
                color: theme.foregroundMuted,
            }}
        >
            {hint}
        </div>
        
    );

});

// Dev Tools
ModalHint.displayName = 'ModalHint';

export default ModalHint;

